if (!customElements.get('rone-gallery')) {
  customElements.define(
    'rone-gallery',
    class RoneGallery extends HTMLElement {
      connectedCallback() {
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.mainImg = this.querySelector('[data-gallery-img]');
        this.prevBtn = this.querySelector('[data-gallery-prev]');
        this.nextBtn = this.querySelector('[data-gallery-next]');
        this.index = 0;

        this.thumbs.forEach((thumb, i) => {
          thumb.addEventListener('click', () => this.show(i));
        });
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.show(this.index - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.show(this.index + 1));

        this.attachSwipe();
      }

      show(index) {
        if (!this.thumbs.length) return;
        this.index = Math.max(0, Math.min(this.thumbs.length - 1, index));
        const thumb = this.thumbs[this.index];

        this.thumbs.forEach((t) => t.classList.remove('rone-gallery__thumb--on'));
        thumb.classList.add('rone-gallery__thumb--on');

        this.mainImg.src = thumb.dataset.src;
        this.mainImg.alt = thumb.dataset.alt || '';

        if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.index === this.thumbs.length - 1;

        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }

      attachSwipe() {
        const main = this.querySelector('.rone-gallery__main');
        if (!main) return;
        let startX = null;
        main.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(dx) < 40) return;
          this.show(this.index + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    }
  );
}
